import { Select, Stack } from '@mantine/core'
import { invariant } from '@seen/core/invariant'
import {
  SDR_ACTION_STATE_SELECT_OPTIONS,
  type SDRAction,
  type SDRActionState,
} from '@seen/core/models/tasks/sdr/sdr-action'
import { Button } from '@seen/ui'
import { type JSX, useState } from 'react'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'
import { usePatchMutation } from '#src/hooks/usePatchMutation.ts'

export function EditSDRActionState({
  sdrAction,
}: {
  sdrAction: SDRAction
}): JSX.Element {
  const isReadOnly = useIsReadOnly()
  const [sdrActionState, setSDRActionState] = useState<SDRActionState | null>(
    null
  )
  const patch = usePatchMutation<SDRAction>()

  const handleSubmit = (): void => {
    invariant(sdrActionState, 'SDR action state is required')

    patch.mutate({
      instance: sdrAction,
      mutateFn: (sdrAction) => {
        sdrAction.state = sdrActionState
      },
    })
  }

  return (
    <Stack>
      <Select
        name="SDR_ACTION_STATE"
        data={SDR_ACTION_STATE_SELECT_OPTIONS}
        value={sdrActionState}
        onChange={(value) => setSDRActionState(value as SDRActionState)}
        searchable
        disabled={isReadOnly}
      />
      <Button
        onClick={handleSubmit}
        loading={patch.isPending}
        disabled={isReadOnly}
      >
        Save
      </Button>
    </Stack>
  )
}
